import { render, staticRenderFns } from "./pressReleases.vue?vue&type=template&id=cfaeadd4&scoped=true"
import script from "./pressReleases.vue?vue&type=script&lang=js"
export * from "./pressReleases.vue?vue&type=script&lang=js"
import style0 from "./pressReleases.vue?vue&type=style&index=0&id=cfaeadd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfaeadd4",
  null
  
)

export default component.exports